"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAmountInputField = void 0;
exports.createAmountInputBox = createAmountInputBox;
/*
 UI to enter an Amount. It will be entered in a specified unit and decimal count.
 The passed Amount value will be converted to the specified unit and decimal count if needed.
 The UI will ensure that the value is numeric before emitting a change event.
 It is also allowed to have a blank input in which case a change event with value of undefined will be emitted.
 */
const react_1 = __importDefault(require("react"));
const uom_1 = require("uom");
const amount_input_field_1 = require("./amount-input-field");
// function inputInvalidLocked({
//   isReadonly,
//   effectiveErrorMessage
// }: AmountInputFieldProps): StyledComponents.InterpolationValue[] {
//   if (isReadonly && effectiveErrorMessage) {
//     return StyledComponents.css`
//     background: lightgray;
//     color: red;
//     border: none;
//   `;
//   }
//   return [];
// }
function inputInvalidLocked({ isReadonly, effectiveErrorMessage }) {
    if (isReadonly && effectiveErrorMessage) {
        return {
            background: "lightgray",
            color: "red",
            border: "none"
        };
    }
    return {};
}
function inputLocked({ isReadonly, effectiveErrorMessage }) {
    if (isReadonly && !effectiveErrorMessage) {
        return {
            background: "lightgray",
            color: "darkgray",
            border: "none"
        };
    }
    return {};
}
const defaultAmountInputField = (props) => (react_1.default.createElement(amount_input_field_1.AmountInputField, Object.assign({}, props, { style: Object.assign(Object.assign({ color: !props.isReadonly && props.effectiveErrorMessage ? "red" : "black", height: "30px", border: "1px solid #b4b4b4", borderRadius: "3px", font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif", outline: "rgb(131, 131, 131) none 0px", padding: "1px 30px 0px 10px" }, inputInvalidLocked(props)), inputLocked(props)) })));
exports.defaultAmountInputField = defaultAmountInputField;
function createAmountInputBox({ AmountInputField = exports.defaultAmountInputField }) {
    // eslint-disable-next-line functional/no-class
    return class AmountInputBox extends react_1.default.Component {
        constructor(props) {
            super(props);
            // What the optimal debounce is may vary between users. 350ms seems like a nice value...
            this._debouncedOnValueChange = debounce(this, this._debouncedOnValueChange, this.props.debounceTime);
        }
        componentWillMount() {
            this.initStateFromProps(this.props);
        }
        componentWillReceiveProps(nextProps) {
            this.initStateFromProps(nextProps);
        }
        initStateFromProps(initProps) {
            const { value, inputUnit, inputDecimalCount } = initProps;
            if (!inputUnit) {
                console.error("Missing inputUnit");
            }
            if (!(inputDecimalCount !== null && inputDecimalCount !== undefined)) {
                console.error("Missing inputDecimalCount");
            }
            const formattedValue = formatWithUnitAndDecimalCount(value, inputUnit, inputDecimalCount);
            const newState = calculateNewState(value, formattedValue, initProps.isRequiredMessage, initProps.notNumericMessage, initProps.errorMessage);
            this.setState(newState);
        }
        render() {
            const { onValueChange, readOnly, onBlur, onFocus } = this.props;
            const { effectiveErrorMessage, textValue } = this.state;
            // const test = (<input type="text" />);
            return (react_1.default.createElement(AmountInputField, { key: "input", value: textValue, readOnly: readOnly, onBlur: onBlur, onFocus: onFocus, onChange: e => this._onChange(e, onValueChange), title: effectiveErrorMessage, effectiveErrorMessage: effectiveErrorMessage, isReadonly: readOnly }));
        }
        _debouncedOnValueChange(newAmount, onValueChange) {
            // An event can have been received when the input was valid, then the input has gone invalid
            // but we still received the delayed event from when the input was valid. Therefore
            // we need an extra check here to make sure that the current input is valid before we
            // dispatch the value change.
            if (this.state.isValid) {
                onValueChange(newAmount);
            }
        }
        _onChange(e, onValueChange) {
            const newStringValue = e.currentTarget.value.replace(",", ".");
            const { inputUnit, inputDecimalCount } = this.props;
            // If the change would add more decimals than allowed then ignore the change
            const stringDecimalCount = getDecimalCountFromString(newStringValue);
            if (stringDecimalCount > inputDecimalCount) {
                return;
            }
            // Update the internal state and if the change resulted in a valid value then emit a change with that value
            const newAmount = unformatWithUnitAndDecimalCount(newStringValue, inputUnit, inputDecimalCount);
            const newState = calculateNewState(newAmount, newStringValue, this.props.isRequiredMessage, this.props.notNumericMessage, this.props.errorMessage);
            this.setState(newState);
            // We need to check isValid from the new state because state is not immidiately mutated
            if (newState.isValid) {
                this._debouncedOnValueChange(newAmount, onValueChange);
            }
        }
    };
}
function calculateNewState(newAmount, newStringValue, isRequiredMessage, notNumericMessage, errorMessage) {
    const internalErrorMessage = getInternalErrorMessage(newAmount, newStringValue, isRequiredMessage, notNumericMessage);
    if (internalErrorMessage) {
        return {
            isValid: false,
            textValue: newStringValue,
            effectiveErrorMessage: internalErrorMessage
        };
    }
    else {
        return {
            isValid: true,
            textValue: newStringValue,
            effectiveErrorMessage: errorMessage
        };
    }
}
function getInternalErrorMessage(newAmount, newStringValue, isRequiredMessage, notNumericMessage) {
    // Check if blank and if required or not
    if (newStringValue.trim() === "" && isRequiredMessage) {
        // The user has not entred anything, but a value was required
        return isRequiredMessage;
    }
    if (newStringValue.trim() !== "" && !newAmount && isRequiredMessage) {
        // The user has entered something, but it could not be converted to an amount (=was not numeric)
        return notNumericMessage;
    }
    return undefined;
}
function formatWithUnitAndDecimalCount(amount, unit, decimalCount) {
    if (!amount) {
        return "";
    }
    // Determine the value to use
    let valueToUse;
    if (amount.unit === unit) {
        // No conversion needed, use the original number of decimals in the amount
        valueToUse = amount.value;
        // Determine number of decimals
        if (amount.decimalCount <= decimalCount) {
            return valueToUse.toFixed(amount.decimalCount);
        }
        else {
            return valueToUse.toFixed(decimalCount);
        }
    }
    else {
        // Conversion needed, use the max number of decimals so the conversion
        // result is as accurate as possible
        valueToUse = uom_1.Amount.valueAs(unit, amount);
        return valueToUse.toFixed(decimalCount);
    }
}
function unformatWithUnitAndDecimalCount(text, unit, inputDecimalCount) {
    if (!text || text.length === 0) {
        return undefined;
    }
    const parsedFloatValue = filterFloat(text);
    // biome-ignore lint: -
    if (isNaN(parsedFloatValue)) {
        return undefined;
    }
    // Keep number of decimals from the entered text except if they are more than the formats decimal count
    const textDecimalCount = getDecimalCountFromString(text);
    const finalDecimalCount = textDecimalCount > inputDecimalCount ? inputDecimalCount : textDecimalCount;
    const finalFloatValue = textDecimalCount > inputDecimalCount
        ? parseFloat(parsedFloatValue.toFixed(inputDecimalCount))
        : parsedFloatValue;
    return uom_1.Amount.create(finalFloatValue, unit, finalDecimalCount);
}
function getDecimalCountFromString(stringValue) {
    const pointIndex = stringValue.indexOf(".");
    if (pointIndex >= 0) {
        return stringValue.length - pointIndex - 1;
    }
    return 0;
}
function filterFloat(value) {
    // biome-ignore lint: -
    if (/^(\-|\+)?([0-9]*?(\.[0-9]+)?|Infinity)$/.test(value)) {
        return Number(value);
    }
    return NaN;
}
// (From underscore.js)
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds.
function debounce(_this, func, wait) {
    let timeout;
    return function () {
        // biome-ignore lint: -
        const args = arguments;
        const later = function () {
            timeout = null;
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
//# sourceMappingURL=amount-input-box.js.map